module.exports = __webpack_public_path__ + "Simple-Line-Icons.svg";


//////////////////
// WEBPACK FOOTER
// ./~/simple-line-icons/fonts/Simple-Line-Icons.svg?v=2.4.0
// module id = 1120
// module chunks = 8